import axios from 'axios'

declare module 'axios' {
  export interface AxiosRequestConfig {
    requireAuth?: boolean
  }
}

const instance = axios.create({
  baseURL: `/api/`,
})

export default instance
